import styled from 'styled-components';
import { ifProp } from 'styled-tools';
import { colours } from 'themes/default';
import { bookingStatus } from 'types/booking';

export const StyledMismatchDataContainer = styled.div`
  margin: 20px 0 0px;
`;

export const StyledContentContainer = styled.div`
  display: flex;
  margin-bottom: ${ifProp('marginBot', '10px')};
`;

export const StyledContent = styled.span`
  margin-right: 5px;
  font-weight: ${ifProp('bold', 'bold')};
`;
export const StyledStatus = styled.span`
  color: ${({ status }) => (status === bookingStatus.CANCELLED ? colours.Messaging.ErrorRed : colours.Messaging.SuccessGreen)};
  font-weight: bold;
`;
